import { render } from "./MemberMeta.vue?vue&type=template&id=130dbc68&scoped=true&bindings={\"userId\":\"data\",\"totalSavings\":\"data\",\"uniflexTotal\":\"data\",\"devloanTotal\":\"data\",\"walletBalance\":\"data\",\"error\":\"data\"}"
import script from "./MemberMeta.vue?vue&type=script&lang=js"
export * from "./MemberMeta.vue?vue&type=script&lang=js"

import "./MemberMeta.vue?vue&type=style&index=0&id=130dbc68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-130dbc68"

export default script